// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2JsQX","rootSuccess":"CompleteLink_rootSuccess__2FbAe","rootFailure":"CompleteLink_rootFailure__2D3HO","isDisabled":"CompleteLink_isDisabled__3dp5t"};